import React, {FC, useEffect, useState} from 'react'
import '../../../../_metronic/assets/css/Taspen.css'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import MudikCarousel from './components/MudikCarousel'
import LocationSearchOverlay from './components/LocationSearchOverlay'
import {useNavigate} from 'react-router-dom'
import {LocationMudik, SearchMode} from './model/Pegadaian.types'
import {getDestinations, getOrigins, RouteSearchResponse, searchRoute} from './api/pegadaianApi'
import Swal from 'sweetalert2'

const PegadaianPage: FC = () => {
  const [searchMode, setSearchMode] = useState<SearchMode | null>(null)
  const navigate = useNavigate()
  const [showQuotaModal, setShowQuotaModal] = useState(false)
  const [isQuotaFull, setIsQuotaFull] = useState(true) // Set true untuk disable input

  useEffect(() => {
    const timer = setTimeout(() => setShowQuotaModal(true), 500)
    return () => clearTimeout(timer)
  }, [])
  const [tempSearch, setTempSearch] = useState('')
  const [selectedOrigin, setSelectedOrigin] = useState<string>('')
  const [selectedDestination, setSelectedDestination] = useState<string>('')
  const [routes, setRoutes] = useState<RouteSearchResponse[]>([])
  const [loading, setLoading] = useState(false)

  const openSearch = (mode: SearchMode) => {
    setSearchMode(mode)
    setTempSearch('')
  }

  const handleSelect = (loc: string, mode: SearchMode) => {
    if (mode === 'origin') {
      setSelectedOrigin(loc)
      setSelectedDestination('') // Reset destination jika origin berubah
      setRoutes([]) // Bersihkan rute lama
    } else {
      setSelectedDestination(loc)
    }

    setSearchMode(null)
    setTempSearch('')
  }

  const handleSearch = async () => {
    if (!selectedOrigin || !selectedDestination) {
      await Swal.fire({
        icon: 'warning',
        title: 'Data Belum Lengkap',
        text: 'Pilih origin dan destination terlebih dahulu.',
        confirmButtonColor: '#72BF44',
      })
      return
    }

    try {
      setLoading(true)

      const data = await searchRoute(selectedOrigin, selectedDestination)

      if (!data || data.length === 0) {
        setRoutes([])

        await Swal.fire({
          icon: 'info',
          title: 'Rute Tidak Ditemukan',
          text: 'Tidak ada rute tersedia untuk pilihan tersebut.',
          confirmButtonColor: '#72BF44',
        })

        return
      }

      setRoutes(data)
    } catch (error: any) {
      const message = error?.response?.data?.message || 'Terjadi kesalahan saat mencari rute.'

      await Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: message,
        confirmButtonColor: '#72BF44',
      })

      setRoutes([])
    } finally {
      setLoading(false)
    }
  }

  const handleSelectTicket = (route: RouteSearchResponse) => {
    navigate('/mudik-bersama/pegadaian/booking', {
      state: {
        ...route,
        selectedDestinationName: route.destinationSelectedParams,
      },
    })
  }

  const hendleSearchBooking = () => {
    navigate('/mudik-bersama/pegadaian/check-booking')
  }

  return (
    <>
      {showQuotaModal && (
        <div
          className='position-absolute w-100 h-100 d-flex align-items-center justify-content-center px-4'
          style={{
            zIndex: 999,
            backgroundColor: 'rgba(0,0,0,0.6)',
            backdropFilter: 'blur(4px)',
            top: 0,
            left: 0,
            borderRadius: 'inherit',
          }}
        >
          <div
            className='bg-white p-5 text-center shadow-lg d-flex flex-column'
            style={{
              borderRadius: '24px',
              maxWidth: '400px',
              minHeight: '500px',
              border: '1px solid #72BF44',
            }}
          >
            {/* Konten Atas */}
            <div className='mt-2'>
              <img
                src={toAbsoluteUrl('/img/icon-bus.png')}
                alt='Bus'
                style={{
                  width: '140px',
                  marginBottom: '1.5rem',
                }}
              />
              <h3
                className='fw-bolder mb-3'
                style={{color: '#333', fontSize: '1.4rem', lineHeight: '1.3'}}
              >
                Pendaftaran Mudik Bersama Telah Ditutup
              </h3>
              <p className='text-muted fs-7 px-1' style={{lineHeight: '1.6'}}>
                Terima kasih atas antusiasme Anda. Saat ini kuota telah terpenuhi dan
                <span className='fw-bold text-dark'> pendaftaran resmi ditutup.</span>
                <br />
                <br />
                Bagi Anda yang sudah mendaftar, silakan cek status pemesanan melalui tombol di bawah
                ini.
              </p>
            </div>

            {/* Konten Bawah (Buttons) */}
            <div className='mt-auto d-grid gap-2'>
              <button
                className='btn py-3 fw-bold text-white'
                onClick={hendleSearchBooking}
                style={{
                  backgroundColor: '#72BF44',
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(114, 191, 68, 0.3)',
                  border: 'none',
                }}
              >
                Cek Status Booking
              </button>

              <button
                className='btn py-3 fw-bold'
                style={{
                  backgroundColor: 'transparent',
                  color: '#72BF44',
                  borderRadius: '12px',
                  border: '2px solid #72BF44',
                }}
                onClick={() => setShowQuotaModal(false)}
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
      <div className='container-xxl p-0'>
        <div className='row justify-content-center mx-0 '>
          <div
            className='col-12 col-md-8 col-lg-5 p-0 bg-white pb-md-10 mx-auto'
            style={{position: 'relative'}}
          >
            {searchMode && (
              <LocationSearchOverlay
                mode={searchMode}
                searchValue={tempSearch}
                setSearchValue={setTempSearch}
                onClose={() => setSearchMode(null)}
                onSelect={handleSelect}
                fetchOrigins={getOrigins}
                fetchDestinations={getDestinations}
                selectedOrigin={selectedOrigin}
              />
            )}

            <div
              className='position-relative w-100 overflow-hidden'
              style={{borderEndEndRadius: 20, borderEndStartRadius: 20}}
            >
              {/* Background Image */}
              <img
                src={toAbsoluteUrl('/img/pegadaian-bg.png')}
                alt='Background'
                className='w-100 d-block'
                style={{
                  height: 'clamp(190px, 24vw, 230px)',
                  objectFit: 'cover',
                }}
              />

              <div
                className='position-absolute top-0 start-0 w-100 d-flex align-items-center justify-content-between'
                style={{
                  padding: 'clamp(14px, 4vw, 24px)',
                }}
              >
                {/* Logo */}
                <img
                  src={toAbsoluteUrl('/img/pegadaian-logo.png')}
                  alt='pegadaian'
                  style={{
                    height: 'clamp(28px, 5vw, 36px)',
                    objectFit: 'contain',
                  }}
                />

                {/* Ticket Button */}
                <button
                  className='btn btn-light d-flex align-items-center shadow-sm'
                  onClick={hendleSearchBooking}
                  style={{
                    borderRadius: '10px',
                    fontSize: 'clamp(12px, 3vw, 14px)',
                    padding: '6px 12px',
                    color: '#72BF44',
                    fontWeight: 600,
                  }}
                >
                  <i className='bi bi-ticket-perforated me-2'></i>
                  <span className='d-sm-inline'>Check Booking</span>
                </button>
              </div>
            </div>

            <div
              className='card mx-4 shadow position-relative'
              style={{
                marginTop: 'clamp(-120px, -40vw, -60px)',
                borderRadius: '16px',
                border: 'none',
                zIndex: 10,
              }}
            >
              <div className='card-body p-4'>
                <h4 className='mb-4' style={{fontFamily: 'serif'}}>
                  <span style={{color: '#72BF44', fontWeight: 'bold'}}>Mudik</span>{' '}
                  <span style={{color: '#BFD730', fontWeight: 'bold'}}>Bersama</span>
                </h4>
                {/* Input Origin */}
                <div
                  className={`mb-4 ${isQuotaFull ? 'opacity-75' : 'cursor-pointer'}`}
                  onClick={() => !isQuotaFull && openSearch('origin')}
                >
                  <div className={`input-group border rounded-3 p-3 align-items-center bg-light`}>
                    <span className='me-3' style={{color: isQuotaFull ? '#a1a5b7' : '#72BF44'}}>
                      <KTIcon iconName='geolocation' className='fs-3' iconType='solid' />
                    </span>
                    <input
                      type='text'
                      readOnly
                      disabled={isQuotaFull}
                      className='form-control border-0 p-0 bg-transparent fs-7'
                      style={{cursor: 'not-allowed'}}
                      placeholder='Lokasi Keberangkatan (Quota Penuh)'
                      value={selectedOrigin}
                    />
                  </div>
                </div>

                {/* Input Destination */}
                <div className={`mb-4 opacity-75`} style={{cursor: 'not-allowed'}}>
                  <div className={`input-group border rounded-3 p-3 align-items-center bg-light`}>
                    <span className='me-3 text-gray-400'>
                      <KTIcon iconName='geolocation-home' className='fs-3' iconType='solid' />
                    </span>
                    <input
                      type='text'
                      readOnly
                      disabled
                      className='form-control border-0 p-0 bg-transparent fs-7'
                      style={{cursor: 'not-allowed'}}
                      placeholder='Lokasi Tujuan'
                      value={selectedDestination}
                    />
                  </div>
                </div>

                <button
                  onClick={handleSearch}
                  disabled={loading}
                  className='btn w-100 py-3 fw-bold text-white'
                  style={{
                    backgroundColor: '#72BF44',
                    borderRadius: '40px',
                    fontSize: '16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                  }}
                >
                  {loading ? (
                    <>
                      <span
                        className='spinner-border spinner-border-sm'
                        role='status'
                        aria-hidden='true'
                      ></span>
                      Memuat...
                    </>
                  ) : (
                    'Cari'
                  )}
                </button>
              </div>
            </div>

            <MudikCarousel />
            <div className='px-4 mb-10'>
              <h5 className='fw-bold mb-3'>Tiket Tersedia</h5>

              {loading ? (
                <div className='text-center py-10'>
                  <div className='spinner-border text-success mb-3' role='status'></div>
                  <p className='text-muted'>Mencari jadwal terbaik...</p>
                </div>
              ) : routes.length > 0 ? (
                routes.map((route) => (
                  <div
                    key={route.id}
                    className='card border-0 mb-3 py-3'
                    style={{backgroundColor: '#f1f1f1', borderRadius: '12px'}}
                  >
                    <div className='card-body p-3'>
                      {/* Info Tanggal Keberangkatan */}
                      <div className='mb-3'>
                        <span className='text-muted' style={{fontSize: '13px'}}>
                          Keberangkatan :
                        </span>
                        <span className='fw-bold text-success ms-2' style={{fontSize: '13px'}}>
                          {new Date(route.schDate).toLocaleDateString('id-ID', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })}{' '}
                          • {route.estimasi}
                        </span>
                      </div>

                      {/* Card Detail Perjalanan */}
                      <div className='card border-0 shadow-sm' style={{borderRadius: '12px'}}>
                        <div className='card-body p-3'>
                          <div className='row align-items-center'>
                            {/* Kolom Waktu & Estimasi */}
                            <div className='col-3 text-center'>
                              <div className='fw-bold mb-0'>{route.sta ?? '-- : --'}</div>
                              <div className='text-muted small'>
                                {new Date(route.schDate).toLocaleDateString('id-ID', {
                                  day: '2-digit',
                                  month: 'short',
                                })}
                              </div>
                              <div className='fw-bold mb-0'>{route.std ?? '-- : --'}</div>
                            </div>

                            {/* Kolom Rute & Tombol Pilih */}
                            <div className='col-9 border-start position-relative ps-4'>
                              <div className='mb-4'>
                                <h6 className='fw-bold mb-1'>
                                  {route.origin} - {route.destination}
                                </h6>
                                <p className='text-muted mb-0' style={{fontSize: '12px'}}>
                                  {route.route}
                                </p>
                              </div>

                              <div className='d-flex justify-content-between align-items-end'>
                                <div>
                                  <h6 className='fw-bold mb-0 text-success'>
                                    Destinasi : {route.destinationSelectedParams}
                                  </h6>
                                  <div className='fw-bold mt-1'>{route.sta ?? '-'}</div>
                                </div>

                                <button
                                  onClick={() => handleSelectTicket(route)}
                                  className='btn btn-success px-6'
                                  style={{
                                    borderRadius: '20px',
                                    backgroundColor: '#72BF44',
                                    border: 'none',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                  }}
                                >
                                  Pilih
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                /* Tampilan Jika Data Kosong */
                <div
                  className='card border-3 text-center p-10 border-secondary border-dotted'
                  style={{borderRadius: '16px', backgroundColor: '#f8f9fa'}}
                >
                  <div className='card-body'>
                    <i
                      className='bi bi-search text-muted mb-3 d-block'
                      style={{fontSize: '3rem'}}
                    ></i>
                    <h6 className='fw-bold text-muted'>Belum Ada Rute Tersedia</h6>
                    <p className='text-muted small mb-0'>
                      Coba pilih lokasi keberangkatan atau tujuan lainnya.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PegadaianPage